import {disableDarkModeIfNotClosest} from "../utilities/domGeneralManipulation";
import {disableSearch} from '../components/searchBar';
import {disableAllMegaMenu} from '../components/navigation';

export const bodyListener = () => {
    const bodyListenerHandler = (e) => {
        const disableDarkMode = disableDarkModeIfNotClosest(e, '.header');

        if(disableDarkMode) {
            disableAllMegaMenu();
            disableSearch();
            return;
        }
    }

    document.body.addEventListener('click', bodyListenerHandler);
}
